enum UserStatusType {
  READY = 'READY',
  START = 'START',
  PDF_UPLOAD = 'PDF_UPLOAD',
  COMPLETED = 'COMPLETED',
  ENCODING_COMPLETED = 'ENCODING_COMPLETED',
}

export default UserStatusType;